import { render, staticRenderFns } from "./LongTranslate.vue?vue&type=template&id=aad37ef8"
import script from "./LongTranslate.vue?vue&type=script&lang=js"
export * from "./LongTranslate.vue?vue&type=script&lang=js"
import style0 from "./LongTranslate.vue?vue&type=style&index=0&id=aad37ef8&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports